import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchExerciseDetails = (
  exerciseId: string,
  setExercise: Function,
  setLoaded: Function,
  language: string
) => {
  setLoaded(false);

  ApiService.get(`exercises/${exerciseId}?get_owner_infos=true&get_module_infos=true&fetch_required_resources=true`)
    .then((response) => setExercise(response.data.exercise))
    .catch((error) => {
      console.error("Error while loading exercise:", error);
      alert(translate(language, "PAGES.EXERCISE.ERROR.FETCH_EXERCISE"));
    })
    .finally(() => setLoaded(true));
};
